import ApplicationController from './application_controller'
import {
  centerMapOnMarkers, drawLineBetweenMarkers, addMarkers
} from './utils/google-map'
import { loadGoogleMaps } from './utils/google_maps_loader'

export default class extends ApplicationController {
  static targets = ['output']
  static values = {
    latLngStart: Object,
    latLngEnd: Object
  }

  #defaultZoom = 4

  async connect () {
    await loadGoogleMaps()
    if (!this.element.isConnected) return

    const map = new google.maps.Map(this.outputTarget, {
      zoom: this.#defaultZoom
    })

    const markerLatLngList = [
      // TODO: move that into a value with an array of latLng json
      this.latLngStartValue,
      this.latLngEndValue
    ]

    const markers = addMarkers(map, markerLatLngList)
    drawLineBetweenMarkers(map, markers)
    centerMapOnMarkers(map, markers)
  }
}
